<template>
  <v-container class="margen_paginas pt-7" fluid>
    <v-card class="mb-n4" style="background-color: #E8EAF6;">
      <v-card-title class="pa-2 pl-4" style="background: #b0b0c0">
        <v-icon class="mr-3">mdi-monitor</v-icon>
        <span style="font-size: 20px; font-weight: 400">{{ $t ('Sinóptico de aparcamiento') }}</span>
      </v-card-title>

      <v-container fluid style="background: #dcdcd0; border-bottom: 1px solid #BBBBBB">
        <v-row>
          <!-- aparcamiento -->
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-select
              class="mt-3 mb-n2"
              :items="instalaciones"
              item-value="id_ins"
              item-text="nom"
              v-model="instalacionSeleccionada"
              return-object
              :label="$t ('Aparcamiento')"
              background-color="#dcdcd0"
              prepend-icon="mdi-file-powerpoint-box"
              dense
              hide-details
              :disabled="instalaciones.length < 2"
              :menu-props="{ maxHeight: '80vh' }"
              @change="seleccionInstalacion"
            ></v-select>
          </v-col>
        </v-row>
        <div v-if="!instalacionSeleccionada" style="height: 12px"></div>
      </v-container>

      <v-container v-if="instalacionSeleccionada" fluid>
        <v-btn-toggle
          v-model="vista"
          mandatory
          class="mb-3 mt-1"
          background-color="#9FA8DA"
          color="#D81B60"
          dense
        >
          <v-btn value="aparatos" class="px-5">
            <v-icon left>mdi-boom-gate</v-icon>{{ $t ('Aparatos') }}
          </v-btn>

          <v-btn value="zonas" class="px-5">
            <v-icon left>mdi-select-marker</v-icon>{{ $t ('Zonas') }}
          </v-btn>
        </v-btn-toggle>

        <!-- <v-subheader class="pl-1 mt-n2 mb-n5">{{ $t ('Aparatos') }}</v-subheader> -->

        <div v-show="vista == 'aparatos'">
          <v-row class="py-1">
            <!-- <v-col cols="12" class="d-flex justify-center align-center">
              <v-progress-circular
                :size="70"
                color="#8080b0"
                indeterminate
                class="ma-6"
              ></v-progress-circular>
            </v-col>-->

            <v-col cols="12">
              <span v-for="aparato in aparatos_IS" :key="aparato.cod">
                <div style="width: 156px; display: inline-block" class="mr-2 mb-2">
                  <ControlRemotoAparato
                    :objeto-aparato="aparato"
                    :objeto-estados="$global.estadoAparatos"
                    :objeto-ultimas-incidencias="$global.ultimasIncidenciasAparatos"
                    :sagabroker="$sagabroker"
                    :iconos-grandes="false"
                    :ventana-gestion-poste="$refs['vgp']"
                    :ventana-gestion-cajero="$refs['vgca']"
                    :ventana-seleccion-cobro-para-imprimir="$refs['vscpi']"
                    :ventana-gestion-ticket-perdido="$refs['vgtp']"
                    @evento-asistencia-remota="mostrarAsistenciaRemotaAparato"
                  />
                </div>
              </span>
            </v-col>

            <!-- <pre>{{aparatos_IS}}</pre> -->
            <!-- <pre>{{$global.estadoAparatos}}</pre> -->
          </v-row>
          <v-row dense>
            <v-col cols="12">
              <VisorEventosSAGA
                :key="instalacionSeleccionada.id_ins"
                :id-instalacion="instalacionSeleccionada.id_ins"
                :titulo="$t ('Eventos')"
                busqueda-rapida
                dense
              />
            </v-col>
          </v-row>
        </div>

        <div v-show="vista == 'zonas'">
          <v-row class="py-1">
            <v-col cols="12">
              <!-- {{$global.estadoInstalaciones [instalacionSeleccionada.id_ins]}} -->
              <!-- {{$global.estadoInstalaciones}} -->
              <span v-for="(zona, indice) in zonas_IS" :key="indice">
                <div style="width: 156px; display: inline-block" class="mr-2 mb-2">
                  <v-card elevation="4">
                    <v-card-text class="pa-3">
                      <div style="width: 90%">
                        <h4 class="mb-1">{{zona.descripcion}}</h4>
                      </div>
                      <v-btn text fab icon x-small absolute style="top: 5px; right: 2px" @click="ajustarPlazasZona (zona)"><v-icon>mdi-dots-vertical</v-icon></v-btn>

                      <center>
                        <v-progress-circular
                          class="my-1"
                          :size="120"
                          :width="8"
                          :rotate="180"
                          :value="zona.plazas_ocupadas * 100 / zona.total_plazas"
                          :color="colorCadena(zona.descripcion)"
                        >
                          <div style="color: #888">
                            <!-- <div>TOTAL: <span style="font-weight: 700">{{zona.total_plazas}}</span></div>
                            <div>Libres: <span style="color: black; font-weight: 700; font-size: 20px">{{zona.total_plazas - zona.plazas_ocupadas}}</span></div> -->
                            <div>Plazas libres:</div>
                            <div>
                              <span style="color: black; font-weight: 700; font-size: 20px" :style="{color: colorPlazasLibres (zona.total_plazas - zona.plazas_ocupadas)}" >{{zona.total_plazas - zona.plazas_ocupadas}}</span> / {{zona.total_plazas}}
                            </div>
                          </div>

                        </v-progress-circular>
                      </center>

                    </v-card-text>
                  </v-card>
                </div>
              </span>

            </v-col>
          </v-row>
        </div>
      </v-container>
    </v-card>

    <MonitorizacionAparcamiento
      :id-instalacion="instalacionSeleccionada ? instalacionSeleccionada.id_ins : 0"
    />
    <VentanaGestionPoste ref="vgp" />
    <VentanaGestionCajero ref="vgca" />
    <VentanaSeleccionCobroParaImprimir ref="vscpi" />
    <VentanaGestionTicketPerdido ref="vgtp" />
    <VentanaAjustePlazasZona ref="vapz" />
  </v-container>
</template>

<script>
import api from "@/api";
import ControlRemotoAparato from "@/components/ControlRemotoAparato.vue";
import VentanaGestionPoste from "@/components/VentanaGestionPoste.vue";
import VentanaGestionCajero from "@/components/VentanaGestionCajero.vue";
import VentanaSeleccionCobroParaImprimir from "@/components/VentanaSeleccionCobroParaImprimir.vue";
import VentanaGestionTicketPerdido from "@/components/VentanaGestionTicketPerdido.vue";
import VentanaAjustePlazasZona from "@/components/VentanaAjustePlazasZona.vue";
import VisorEventosSAGA from "@/components/VisorEventosSAGA.vue";
import MonitorizacionAparcamiento from "@/components/MonitorizacionAparcamiento.vue";
import { cadenaAColor } from "@/util";

export default {
  components: {
    ControlRemotoAparato,
    VentanaGestionPoste,
    VentanaGestionCajero,
    VentanaSeleccionCobroParaImprimir,
    VentanaGestionTicketPerdido,
    VentanaAjustePlazasZona,
    MonitorizacionAparcamiento,
    VisorEventosSAGA,
  },
  data() {
    this.idIntervalo = null;
    return {
      vista: "aparatos",
      instalaciones: [],
      aparatos: [],
      dispositivos_interfonia: [],
      instalacionSeleccionada: null,
      ajusteZonaVisible: false,
    };
  },
  computed: {
    aparatos_IS() {
      if (!this.instalacionSeleccionada) return [];
      return this.aparatos.filter(
        (aparato) => aparato.id_ins == this.instalacionSeleccionada.id_ins
      );
    },
    zonas_IS() {
      if (!this.instalacionSeleccionada || !this.$global.estadoInstalaciones [this.instalacionSeleccionada.id_ins]) return [];
      return this.$global.estadoInstalaciones [this.instalacionSeleccionada.id_ins].zonas;
    }
  },
  methods: {
    seleccionInstalacion(instalacion) {
      this.prepararArrayEstadoAparatos();
      this.$store.guardar_preferencia ('id_instalacion_seleccionada', instalacion.id_ins, null, 'controlRemoto');
    },
    prepararArrayEstadoAparatos() {
      let estadoAparatos = this.$global.estadoAparatos;
      this.aparatos_IS.forEach((aparato) => {
        if (!(aparato.cod in estadoAparatos)) {
          let estado = {
            long_name: aparato.des,
            machine_type: aparato.id_tipapa,
            machine_number: aparato.num,
            on_line: false,
          };
          this.$set(this.$global.estadoAparatos, aparato.cod, estado);
        }
      });
    },
    dispositivoInterfoniaAsociado(objetoAparato) {
      return this.dispositivos_interfonia.find(
        (elemento) => elemento.id_apa == objetoAparato.id_apa
      );
    },
    mostrarAsistenciaRemotaAparato(objetoAparato) {
      let dia = this.dispositivoInterfoniaAsociado(objetoAparato);
      if (dia) {
        this.$global.identificadorInterfoniaAGestionar = dia.id_disint;
        this.$router.push({ path: "/panel/asistenciaRemota" });
      }
    },
    colorCadena(cadena) {
      return cadenaAColor(cadena, 65, 60);
    },
    colorPlazasLibres (x) {
      if (x <= 0)
        return "red";
      else if (x < 10)
        return "orange";
      else
        return "black";
    },
    ajustarPlazasZona (zona) {
      let vapz = this.$refs ['vapz'];
      vapz.abrirVentana (zona, cadenaAColor (zona.descripcion, 55, 80))
        .then ((nuevasPlazasZona) => {
          zona.total_plazas = nuevasPlazasZona.total_plazas;
          zona.plazas_libres = nuevasPlazasZona.plazas_libres;
          zona.plazas_ocupadas = nuevasPlazasZona.plazas_ocupadas;
          this.$sagabroker.ajustarPlazasZona (this.instalacionSeleccionada.id_ins, this.$store.operador.correoElectronico, zona.codigo, zona.total_plazas, zona.plazas_libres);
        })
        .catch (() => {

        });
    }
  },
  created() {
    this.$global.actualizarEstadoInstalaciones();

    api
      .obtenerInstalacionesAparatosInterfoniasCamaras()
      .then((respuesta) => {
        this.instalaciones = respuesta.data.instalaciones;
        this.aparatos = respuesta.data.aparatos;
        this.dispositivos_interfonia = respuesta.data.dispositivos_interfonia;

        if (this.instalaciones.length == 1) {
          this.instalacionSeleccionada = this.instalaciones[0];
        } else {
          let ultima_id_instalacion = this.$store.leer_preferencia ('id_instalacion_seleccionada', null, 'controlRemoto');
          this.instalacionSeleccionada = this.instalaciones.find(
            (elemento) => elemento.id_ins == ultima_id_instalacion
          );
        }
      })
      .finally(() => {});
  },
};
</script>

<style scoped>
.v-progress-circular__underlay {
  stroke: #f0f0f0;
}
</style>